<script>
    import { link } from 'svelte-routing';
    import { env } from '../Environment.svelte';
</script>

<div class="wrap">
    <h1 class="text-fs-26 m-b-20">Index</h1>
    <h2 class="fw-semibold">Receivers</h2>
    <a use:link href="/receiver/purchase?token={env.defaultRedirectionToken}"
        >Purchase receiver</a
    >
    <br />
    <br />
    <h2 class="fw-semibold">Purchase</h2>
    <a use:link href="/compra/configura">Config services</a>
    <br />
    <br />
    <h2 class="fw-semibold">Tools</h2>
    <a use:link href="/clean">Clean store</a>
    <br />
    <a use:link href="/store">View store</a>
</div>

<style>
    .wrap {
        padding: 0 20px;
    }
</style>
